enum EDiscountReflected {
  INCLUDE = 'include',
  EXCLUDE = 'exclude',
}

export default EDiscountReflected;
